import { Component, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CategorieEntretienEntite } from 'src/app/entites/mecanique/categorie-entretien';

export interface ParametresAjoutEtapeManuelle {
    categoriesEntretien: CategorieEntretienEntite[];
    etape?: {
        idTemporaire: string;
        description: string;
        categorie?: CategorieEntretienEntite;
        note?: string;
    };
}

export interface ResultatAjoutEtapeManuelle {
    idTemporaire?: string;
    description: string;
    categorie?: CategorieEntretienEntite;
    note?: string;
}

@Component({
    templateUrl: './ajout-etape-manuelle.component.html',
})
export class AjoutEtapeManuelleComponent {

    categoriesEntretien: CategorieEntretienEntite[];
    idTemporaire?: string;
    description = '';
    categorie?: CategorieEntretienEntite;
    note = '';
    submitted = false;

    @ViewChild('champDescription') champDescription;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig<ParametresAjoutEtapeManuelle>,
    ) { }

    ngOnInit() {
        this.categoriesEntretien = this.config.data?.categoriesEntretien ?? [];
        const etape = this.config.data?.etape;
        if (etape) {
            this.idTemporaire = etape.idTemporaire;
            this.description = etape.description ?? '';
            this.categorie = etape.categorie;
            this.note = etape.note ?? '';
        }

        setTimeout(() => this.champDescription?.nativeElement?.focus(), 100);
    }

    confirmer() {
        this.submitted = true;
        if (!this.description?.trim()) {
            return;
        }

        const resultat: ResultatAjoutEtapeManuelle = {
            idTemporaire: this.idTemporaire,
            description: this.description.trim(),
            categorie: this.categorie,
            note: this.note?.trim() || undefined,
        };
        this.ref.close(resultat);
    }

    annuler() {
        this.ref.close(null);
    }

    get modeEdition(): boolean {
        return !!this.idTemporaire;
    }
}
